import { render, staticRenderFns } from "./ModerationModal.vue?vue&type=template&id=b9d49542"
import script from "./ModerationModal.vue?vue&type=script&lang=js"
export * from "./ModerationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports